'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _mobx = require('mobx');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _FormModal = require('../../../lib/mighty-fields/FormModal');

var _FormModal2 = _interopRequireDefault(_FormModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var FIELD_SETS = [[{ field: 'name', label: 'Message name', required: true }, { field: 'message', label: 'Message body', required: true }]];

var SaveSMSReplyModal = (_dec = (0, _mobxReact.inject)('FunderStore', 'UiStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  _inherits(SaveSMSReplyModal, _Component);

  function SaveSMSReplyModal() {
    _classCallCheck(this, SaveSMSReplyModal);

    return _possibleConstructorReturn(this, (SaveSMSReplyModal.__proto__ || Object.getPrototypeOf(SaveSMSReplyModal)).apply(this, arguments));
  }

  _createClass(SaveSMSReplyModal, [{
    key: 'onSave',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
        var _props, FunderStore, UiStore;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props = this.props, FunderStore = _props.FunderStore, UiStore = _props.UiStore;
                _context.next = 3;
                return FunderStore.saveSMSReply(data);

              case 3:
                _context.next = 5;
                return FunderStore.fetchSMSSavedReplies();

              case 5:

                UiStore.modals.SaveSMSReply.close();

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onSave(_x) {
        return _ref.apply(this, arguments);
      }

      return onSave;
    }()
  }, {
    key: 'render',
    value: function render() {
      var onClose = this.props.UiStore.modals.SaveSMSReply.close;

      return _react2.default.createElement(_FormModal2.default, {
        fieldSets: FIELD_SETS,
        onClose: onClose,
        onSave: this.onSave,
        title: 'Save New Message'
      });
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return SaveSMSReplyModal;
}(_react.Component), _class2.propTypes = {
  FunderStore: _propTypes2.default.object.isRequired,
  UiStore: _propTypes2.default.object.isRequired
}, _temp)) || _class) || _class) || _class);
var _default = SaveSMSReplyModal;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(FIELD_SETS, 'FIELD_SETS', '/app/src/components/page-case/sidebar-feed/SaveSMSReplyModal.jsx');
  reactHotLoader.register(SaveSMSReplyModal, 'SaveSMSReplyModal', '/app/src/components/page-case/sidebar-feed/SaveSMSReplyModal.jsx');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/sidebar-feed/SaveSMSReplyModal.jsx');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb21wb25lbnRzL3BhZ2UtY2FzZS9zaWRlYmFyLWZlZWQvU2F2ZVNNU1JlcGx5TW9kYWwuanN4Il0sIm5hbWVzIjpbIkZJRUxEX1NFVFMiLCJmaWVsZCIsImxhYmVsIiwicmVxdWlyZWQiLCJTYXZlU01TUmVwbHlNb2RhbCIsImF1dG9CaW5kTWV0aG9kcyIsIm9ic2VydmVyIiwiZGF0YSIsInByb3BzIiwiRnVuZGVyU3RvcmUiLCJVaVN0b3JlIiwic2F2ZVNNU1JlcGx5IiwiZmV0Y2hTTVNTYXZlZFJlcGxpZXMiLCJtb2RhbHMiLCJTYXZlU01TUmVwbHkiLCJjbG9zZSIsIm9uQ2xvc2UiLCJvblNhdmUiLCJDb21wb25lbnQiLCJwcm9wVHlwZXMiLCJQcm9wVHlwZXMiLCJvYmplY3QiLCJpc1JlcXVpcmVkIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7O0FBQUE7Ozs7QUFDQTs7OztBQUNBOztBQUNBOztBQUNBOzs7O0FBRUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBRUEsSUFBTUEsYUFBYSxDQUNmLENBQ0UsRUFBRUMsT0FBTyxNQUFULEVBQWlCQyxPQUFPLGNBQXhCLEVBQXdDQyxVQUFVLElBQWxELEVBREYsRUFFRSxFQUFFRixPQUFPLFNBQVQsRUFBb0JDLE9BQU8sY0FBM0IsRUFBMkNDLFVBQVUsSUFBckQsRUFGRixDQURlLENBQW5COztJQVVNQyxpQixXQUhMLHVCQUFPLGFBQVAsRUFBc0IsU0FBdEIsQyxvQkFDQUMsZ0MsZUFDQUMsbUI7Ozs7Ozs7Ozs7OzswRkFHZUMsSTs7Ozs7Ozt5QkFDcUIsS0FBS0MsSyxFQUE5QkMsVyxVQUFBQSxXLEVBQWFDLE8sVUFBQUEsTzs7dUJBRWZELFlBQVlFLFlBQVosQ0FBeUJKLElBQXpCLEM7Ozs7dUJBQ0FFLFlBQVlHLG9CQUFaLEU7Ozs7QUFFTkYsd0JBQVFHLE1BQVIsQ0FBZUMsWUFBZixDQUE0QkMsS0FBNUI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs2QkFHUTtBQUNSLFVBQU1DLFVBQVUsS0FBS1IsS0FBTCxDQUFXRSxPQUFYLENBQW1CRyxNQUFuQixDQUEwQkMsWUFBMUIsQ0FBdUNDLEtBQXZEOztBQUVBLGFBQ0UsOEJBQUMsbUJBQUQ7QUFDRSxtQkFBV2YsVUFEYjtBQUVFLGlCQUFTZ0IsT0FGWDtBQUdFLGdCQUFRLEtBQUtDLE1BSGY7QUFJRSxlQUFNO0FBSlIsUUFERjtBQVFEOzs7Ozs7Ozs7OztFQXRCNkJDLGdCLFdBd0J2QkMsUyxHQUFZO0FBQ2pCVixlQUFhVyxvQkFBVUMsTUFBVixDQUFpQkMsVUFEYjtBQUVqQlosV0FBU1Usb0JBQVVDLE1BQVYsQ0FBaUJDO0FBRlQsQztlQU1ObEIsaUI7Ozs7Ozs7Ozs7OzBCQXhDVEosVTswQkFVQUksaUIiLCJmaWxlIjoiU2F2ZVNNU1JlcGx5TW9kYWwuanN4Iiwic291cmNlUm9vdCI6Ii9hcHAiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QsIHsgQ29tcG9uZW50IH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJztcbmltcG9ydCB7IGluamVjdCwgb2JzZXJ2ZXIgfSBmcm9tICdtb2J4LXJlYWN0JztcbmltcG9ydCB7IG9ic2VydmFibGUgfSBmcm9tICdtb2J4JztcbmltcG9ydCBhdXRvQmluZE1ldGhvZHMgZnJvbSAnY2xhc3MtYXV0b2JpbmQtZGVjb3JhdG9yJztcblxuaW1wb3J0IEZvcm1Nb2RhbCBmcm9tICcuLi8uLi8uLi9saWIvbWlnaHR5LWZpZWxkcy9Gb3JtTW9kYWwnO1xuXG5jb25zdCBGSUVMRF9TRVRTID0gW1xuICAgIFtcbiAgICAgIHsgZmllbGQ6ICduYW1lJywgbGFiZWw6ICdNZXNzYWdlIG5hbWUnLCByZXF1aXJlZDogdHJ1ZSB9LFxuICAgICAgeyBmaWVsZDogJ21lc3NhZ2UnLCBsYWJlbDogJ01lc3NhZ2UgYm9keScsIHJlcXVpcmVkOiB0cnVlIH0sXG4gICAgXSxcbl07XG5cbkBpbmplY3QoJ0Z1bmRlclN0b3JlJywgJ1VpU3RvcmUnKVxuQGF1dG9CaW5kTWV0aG9kc1xuQG9ic2VydmVyXG5jbGFzcyBTYXZlU01TUmVwbHlNb2RhbCBleHRlbmRzIENvbXBvbmVudCB7XG5cbiAgYXN5bmMgb25TYXZlIChkYXRhKSB7XG4gICAgY29uc3QgeyBGdW5kZXJTdG9yZSwgVWlTdG9yZSB9ID0gdGhpcy5wcm9wcztcblxuICAgIGF3YWl0IEZ1bmRlclN0b3JlLnNhdmVTTVNSZXBseShkYXRhKTtcbiAgICBhd2FpdCBGdW5kZXJTdG9yZS5mZXRjaFNNU1NhdmVkUmVwbGllcygpO1xuXG4gICAgVWlTdG9yZS5tb2RhbHMuU2F2ZVNNU1JlcGx5LmNsb3NlKCk7XG4gIH1cblxuICByZW5kZXIgKCkge1xuICAgIGNvbnN0IG9uQ2xvc2UgPSB0aGlzLnByb3BzLlVpU3RvcmUubW9kYWxzLlNhdmVTTVNSZXBseS5jbG9zZTtcblxuICAgIHJldHVybiAoXG4gICAgICA8Rm9ybU1vZGFsXG4gICAgICAgIGZpZWxkU2V0cz17RklFTERfU0VUU31cbiAgICAgICAgb25DbG9zZT17b25DbG9zZX1cbiAgICAgICAgb25TYXZlPXt0aGlzLm9uU2F2ZX1cbiAgICAgICAgdGl0bGU9J1NhdmUgTmV3IE1lc3NhZ2UnXG4gICAgICAvPlxuICAgICk7XG4gIH1cblxuICBzdGF0aWMgcHJvcFR5cGVzID0ge1xuICAgIEZ1bmRlclN0b3JlOiBQcm9wVHlwZXMub2JqZWN0LmlzUmVxdWlyZWQsXG4gICAgVWlTdG9yZTogUHJvcFR5cGVzLm9iamVjdC5pc1JlcXVpcmVkLFxuICB9XG59XG5cbmV4cG9ydCBkZWZhdWx0IFNhdmVTTVNSZXBseU1vZGFsO1xuIl19